let DeviceService = /** @class */ (function () {

    /**
     * Get device info, listen device event
     * @param $rootScope{angular.IRootScopeService}
     * @constructor
     */
    function DeviceService( $rootScope) {
        this.$rootScope = $rootScope;
        this.bindEvents();
    }

    DeviceService.prototype = {
        isAppInBackground: false,
        /**
         *
         * @param callback{Function}
         */
        onResume(callback) {
            return this.$rootScope.$on('device-resume',()=>{
                callback();
            })
        },

        /**
         *
         * @param callback{Function}
         */
        onPause(callback) {
            return this.$rootScope.$on('device-pause',()=>{
                callback();
            })
        },
        /**
         *
         * @param callback{Function}
         */
        onBackButton(callback) {
            this.$rootScope.$on('device-back-button',()=>{
                callback();
            })
        },
        bindEvents() {
            document.addEventListener('resume', () => {
                console.log('App in foreground');
                this.isAppInBackground = false;
                this.$rootScope.$emit('device-resume')
            });
            document.addEventListener('pause', () => {
                console.log('App in background');
                this.isAppInBackground = true;
                this.$rootScope.$emit('device-pause')
            });
            document.addEventListener('backbutton', () => {
                this.$rootScope.$emit('device-back-button')
            });
        },
        isOnCordova(){
            return !!window['cordova'];
        },

        /**
         * Listen backbutton on document
         * @param $scope{angular.IScope}
         * @param callback{Function}
         */
        onGoBackButton($scope, callback){
            if(window['cordova']){
                let keydown = (ev)=>{
                    if(ev.keyCode === 27) {
                        callback();
                    }
                }
                document.addEventListener('keydown',keydown);
                $scope.$on("$destroy",()=>{
                    document.removeEventListener('keydown', keydown);
                })
            }
        },
        /**
         * Prevent fire backbutton on currect scope , don't allow user go to back screen 
         * @param $scope{angular.IScope}
         * @param callback{Function}
         */
        preventBackButton($scope){
            if(window['cordova']){
                function keydown(ev){
                    if(ev.keyCode === 27) {
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                    }
                }
                document.body.addEventListener('keydown', keydown, true);
                $scope.$on("$destroy",()=>{
                    document.body.removeEventListener('keydown', keydown, true);
                })
            }
        }
    }
    DeviceService.$inject = ['$rootScope'];
    return DeviceService;
}());
angular.module('shared').service('DeviceService', DeviceService);